angular.module('invoice')
    .service('InvoiceWorkerAbsence', function ($q, Invoice) {
        const uniqueWorkers = workers => {
            let result = []
            const source = workers || []
            source.filter(worker => worker && worker.id != null).forEach(worker => {
                if (!result.some(item => item.id === worker.id)) {
                    result.push(worker)
                }
            })
            return result
        }
        const formatDate = value => moment(value, 'YYYY-MM-DD').format('DD.MM.YYYY')
        const formatPeriod = period => period.from === period.to ? formatDate(period.from) : `${formatDate(period.from)}–${formatDate(period.to)}`
        const isCurrent = period => !moment(period.from, 'YYYY-MM-DD').startOf('day').isAfter(moment().startOf('day'))

        this.find = workers => {
            const normalizedWorkers = uniqueWorkers(workers)
            if (!normalizedWorkers.length) {
                return $q.resolve({})
            }
            return Invoice.workerAbsences({}, {userIds: normalizedWorkers.map(worker => worker.id)}).$promise.then(items => items.reduce((result, item) => {
                result[item.userId] = item
                return result
            }, {}))
        }
        this.get = (absencesByUserId, worker) => worker && absencesByUserId ? absencesByUserId[worker.id] : null
        this.message = workerAbsences => {
            if (!workerAbsences || !workerAbsences.absences || !workerAbsences.absences.length) {
                return null
            }
            return workerAbsences.absences.map(period => isCurrent(period) ? `Wybrana osoba jest nieobecna do ${formatDate(period.to)}.` : `Wybrana osoba będzie nieobecna ${formatPeriod(period)}.`).join(' ')
        }
        this.replacement = workerAbsences => workerAbsences && workerAbsences.absences ? workerAbsences.absences.map(period => period.replacementUser).find(user => user) || null : null
        this.selection = () => {
            const selection = {items: {}, confirmed: {}, loading: false}
            let requestVersion = 0
            selection.clear = () => {
                requestVersion++
                selection.items = {}
                selection.confirmed = {}
                selection.loading = false
            }
            selection.load = workers => {
                const normalizedWorkers = uniqueWorkers(workers)
                const selectedUserIds = normalizedWorkers.reduce((result, worker) => {
                    result[worker.id] = true
                    return result
                }, {})
                selection.confirmed = Object.keys(selection.confirmed).reduce((result, userId) => {
                    if (selectedUserIds[userId]) {
                        result[userId] = selection.confirmed[userId]
                    }
                    return result
                }, {})
                const currentRequestVersion = ++requestVersion
                selection.loading = true
                return this.find(normalizedWorkers).then(items => {
                    if (requestVersion !== currentRequestVersion) {
                        return null
                    }
                    selection.items = items
                    return items
                }).finally(() => {
                    if (requestVersion === currentRequestVersion) {
                        selection.loading = false
                    }
                })
            }
            selection.hasUnconfirmed = workers => uniqueWorkers(workers).some(worker => selection.items[worker.id] && !selection.confirmed[worker.id])
            selection.canProceed = workers => !selection.loading && !selection.hasUnconfirmed(workers)
            selection.validate = workers => selection.load(workers).then(items => items != null && !selection.hasUnconfirmed(workers))
            return selection
        }
    })
    .component('invoiceWorkerAbsence', {
        bindings: {
            worker: '<',
            selection: '<',
            allowedUsers: '<?',
            showWarning: '<?',
            onSelectReplacement: '&?'
        },
        templateUrl: 'app/invoice/worker-absence.html',
        controller: function (InvoiceWorkerAbsence) {
            const ctrl = this

            ctrl.workerAbsences = () => InvoiceWorkerAbsence.get(ctrl.selection && ctrl.selection.items, ctrl.worker)
            ctrl.warningMessage = () => InvoiceWorkerAbsence.message(ctrl.workerAbsences())
            ctrl.replacementUser = () => {
                const replacement = InvoiceWorkerAbsence.replacement(ctrl.workerAbsences())
                return replacement && (ctrl.allowedUsers == null || ctrl.allowedUsers.some(user => user.id === replacement.id)) ? replacement : null
            }
            ctrl.selectReplacement = () => {
                if (angular.isFunction(ctrl.onSelectReplacement)) {
                    ctrl.onSelectReplacement({$worker: ctrl.replacementUser()})
                }
            }
            ctrl.warningVisible = () => ctrl.showWarning !== false && ctrl.workerAbsences()
        }
    })
